import {
  WorkSpaceWithBookingsDocument,
  WorkSpaceWithBookingsQuery,
  WorkSpaceWithBookingsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type WorkSpaceWithBookingNode =
  WorkSpaceWithBookingsQuery['spaceControl']['workSpaceWithBookingsConnection']['edges'][number]['node']

export const useWorkSpaceWithBookings = (variables: {
  date: string
  workSpaceId: number
  endTime?: string
  startTime?: string
}) => {
  const queryVariables: WorkSpaceWithBookingsQueryVariables = {
    date: variables.date ?? new Date().toISOString(),
    workSpaceIds: [variables.workSpaceId],
  }

  if (variables.endTime) {
    queryVariables.endTime = variables.endTime
  }
  if (variables.startTime) {
    queryVariables.startTime = variables.startTime
  }

  const { data, loading, refetch } = useQuery(WorkSpaceWithBookingsDocument, {
    variables: queryVariables,
  })

  const nodes =
    data?.spaceControl.workSpaceWithBookingsConnection.edges.map((edge) => edge.node) ?? []

  return {
    workSpace: nodes.length > 0 ? nodes[0] : null,
    loading,
    refetch,
  }
}
